import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQuery } from 'src/utils/base-query.js'

// Define a service using a base URL and expected endpoints
export const pipelineApi = createApi({
  reducerPath: 'pipelineApi',
  tagTypes: ['PIPELINES'],
  baseQuery,
  keepUnusedDataFor: 0,
  refetchOnReconnect: true,
  refetchOnMountOrArgChange: true,
  endpoints: (builder) => ({
    getPipelinesForWorkspace: builder.query({
      query: (workspaceId) => {
        return {
          method: 'GET',
          url: `deal-pipelines/${workspaceId}`
        }
      },
      providesTags: ['PIPELINES']
    }),
    getPipelinesForUser: builder.query({
      query: ({ workspaceId, userId }) => {
        return {
          method: 'GET',
          url: `deal-pipelines/${workspaceId}/user/${userId}`
        }
      },
      providesTags: ['PIPELINES']
    }),
    createPipeline: builder.mutation({
      query: (data) => {
        return {
          method: 'POST',
          url: 'deal-pipelines',
          body: data
        }
      },
      invalidatesTags: ['PIPELINES']
    }),
    updatePipeline: builder.mutation({
      query: ({ id, data }) => {
        return {
          method: 'PUT',
          url: `deal-pipelines/${id}`,
          body: data
        }
      },
      invalidatesTags: ['PIPELINES']
    }),
    deletePipeline: builder.mutation({
      query: (id) => {
        return {
          method: 'DELETE',
          url: `deal-pipelines/${id}`
        }
      },
      invalidatesTags: ['PIPELINES']
    }),
    updatePipelineValue: builder.mutation({
      query: ({ id, data }) => {
        return {
          method: 'PUT',
          url: `deal-pipelines/${id}/value`,
          body: data
        }
      },
      invalidatesTags: ['PIPELINES']
    }),
    updatePipelineStage: builder.mutation({
      query: ({ pipelineId, stageId, title, valuePerDeal }) => ({
        url: `/deal-pipelines/update/${pipelineId}/stages/${stageId}`,
        method: 'PATCH',
        body: { title, valuePerDeal }
      })
    }),
    reorderPipelineStages: builder.mutation({
      query: ({ pipelineId, orderedStageIds }) => ({
        url: `/deal-pipelines/pipeline-stages/${pipelineId}/stages/reorder`,
        method: 'PATCH',
        body: { orderedStageIds }
      })
    }),
    getPipelineStagesByWorkspace: builder.query({
      query: (workspaceId) => {
        return {
          method: 'GET',
          url: `/deal-pipelines/deal-stages/${workspaceId}`
        }
      }
    }),
    deletePipelineStage: builder.mutation({
      query: ({ pipelineId, stageId, targetStageId, workspaceId }) => ({
        url: '/deal-pipelines/delete-stage/from-pipeline',
        method: 'DELETE',
        body: { pipelineId, stageId, targetStageId, workspaceId }
      })
    })
  })
})

// Export hooks for usage in functional components
export const {
  useGetPipelinesForWorkspaceQuery,
  useGetPipelinesForUserQuery,
  useCreatePipelineMutation,
  useUpdatePipelineMutation,
  useDeletePipelineMutation,
  useUpdatePipelineValueMutation,
  useUpdatePipelineStageMutation,
  useReorderPipelineStagesMutation,
  useGetPipelineStagesByWorkspaceQuery,
  useDeletePipelineStageMutation
} = pipelineApi
